import { Navigate, RouteObject } from "react-router-dom";
import { lazy } from "react";

import App from "../App";
import { Header } from "@/components/Header.tsx";

const Home = lazy(() => import("@/page/Home"));
const Inspections = lazy(() => import("@/page/inspections"));
const InspectionRapid = lazy(() => import("@/page/inspections/InspectionRapid"));
const InspectionSlow = lazy(() => import("@/page/inspections/InspectionSlow"));

const Inspectors = lazy(() => import("@/page/inspectors"));
const InspectorForm = lazy(() => import("@/page/inspectors/InspectorForm"));

const ErrorBoundary = lazy(() => import("@/page/ErrorBoundary"));
const Error404Page = lazy(() => import("@/page/Error404Page"));
const Error500Page = lazy(() => import("@/page/Error500Page"));

const routes: RouteObject[] = [
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: "",
                element: <Home />,
            },
            {
                path: "inspections",
                element: <Header />,
                errorElement: <ErrorBoundary />,
                children: [
                    {
                        path: "",
                        element: <Inspections />,
                    },
                    {
                        path: "rapid",
                        element: <InspectionRapid />,
                    },
                    {
                        path: "slow",
                        element: <InspectionSlow />,
                    },
                    {
                        path: "rapid/:id",
                        element: <InspectionRapid />,
                    },
                    {
                        path: "slow/:id",
                        element: <InspectionSlow />,
                    },
                ],
            },
            {
                path: "inspectors",
                element: <Header />,
                errorElement: <ErrorBoundary />,
                children: [
                    {
                        path: "",
                        element: <Inspectors />,
                    },
                    {
                        path: "new",
                        element: <InspectorForm />,
                    },
                    {
                        path: ":id",
                        element: <InspectorForm />,
                    },
                ],
            },
            {
                path: "404",
                element: <Error404Page />,
            },
            {
                path: "500",
                element: <Error500Page />,
            },
        ],
    },
    {
        path: "*",
        element: <Navigate to="/404" />,
    },
];

export default routes;
